module.exports = __webpack_public_path__ + "img/07655407000287.ddaf4241.png";